import { get } from 'lodash'
import startsWith from 'lodash/startsWith'
import deserialize from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

export const isPerpetual = (license) => false === get(license, ['licenseType', 0, 'subscriptionTermLimited'])
export const isPreOrder = (license) => startsWith(get(license, ['licenseType', 0, 'prefix'], ''), 'FA5')

export default {
  namespaced: true,

  state: {
    list: [],
    item: null,
    evidenceOfProLicense: false
  },

  recall: ['evidenceOfProLicense'],

  getters: {
    currentLicenses: (state) => state.list,
    currentLicense: (state) => state.item,
    hasLicense: (state) => state.list.length > 0,
    evidenceOfProLicense: (state) => state.evidenceOfProLicense,
    hasPerpetualLicense: (state) => !!state.list.find(isPerpetual),
    hasPreOrderLicense: (state) => !!state.list.find(isPreOrder)
  },

  mutations: {
    noLicenses(state) {
      state.evidenceOfProLicense = false
    },

    licensesFetched(state, { licenses }) {
      state.list = licenses
      state.evidenceOfProLicense = licenses.length > 0
    },

    licenseFetched(state, { license }) {
      state.item = license
      state.evidenceOfProLicense = true
    },

    resetState(state) {
      state.list = []
      state.item = null
      state.evidenceOfProLicense = false
    }
  },

  actions: {
    fetchLicenses({ commit }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/licenses`
        })
          .then((response) => {
            deserialize(response.data).then((licenses) => {
              commit('licensesFetched', { licenses })
              resolve()
            })
          })
          .catch((_error) => {
            commit('noLicenses')
            reject()
          })
      })
    }
  }
}
